<template>
  <ModalBase :boxShadow="modalBoxShadow" baseBackground="rgb(255 255 255 / 42%)"
    ><div class="mini-guidelines" :class="sections.five ? 'mini-guidelines-last-slide ' : ''">
      <MiniGuidelinesHeader />
      <SessionGuidelines :sections="sections" />
      <CloseModalButton @closeModal="closeModal" />
      <MiniGuidelinesNavigation :sections="sections" @next="next" @back="back" @setNav="setNav" />
    </div>
  </ModalBase>
</template>

<script>
import ModalBase from "../../InfoModalBase/ModalBase.vue";
import CloseModalButton from "../CloseModalButton/CloseModalButton.vue";
import MiniGuidelinesHeader from "./MiniGuidelinesHeader.vue";
import SessionGuidelines from "./InfoPages/SessionGuidelines.vue";
import MiniGuidelinesNavigation from "./MiniGuidelinesNavigation.vue";

export default {
  name: "InfoModal",
  components: {
    ModalBase,
    CloseModalButton,
    MiniGuidelinesHeader,
    SessionGuidelines,
    MiniGuidelinesNavigation,
  },
  data() {
    return {
      modalBoxShadow: "rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 3px 6px, rgb(213 213 213 / 20%) 0px 9px 24px",

      currentTab: "",

      helpAreas: {
        faq: false,
        guides: false,
        community: false,
        troubleshoot: false,
        safety: false,
        legal: false,
      },
      sections: {
        one: true,
        two: false,
        three: false,
        four: false,
        five: false,
      },
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("modals/setModalState", {
        modal: "miniGuidelines",
        newState: false,
      });
    },
    next() {
      if (this.sections["one"]) {
        this.sections["one"] = false;
        this.sections["two"] = true;
      } else if (this.sections["two"]) {
        this.sections["two"] = false;
        this.sections["three"] = true;
      } else if (this.sections["three"]) {
        this.sections["three"] = false;
        this.sections["four"] = true;
      } else if (this.sections["four"]) {
        this.sections["four"] = false;
        this.sections["five"] = true;
      } else if (this.sections["five"]) {
        this.closeModal();
      }
    },
    back() {
      if (this.sections["two"]) {
        this.sections["two"] = false;
        this.sections["one"] = true;
      } else if (this.sections["three"]) {
        this.sections["three"] = false;
        this.sections["two"] = true;
      } else if (this.sections["four"]) {
        this.sections["four"] = false;
        this.sections["three"] = true;
      } else if (this.sections["five"]) {
        this.sections["five"] = false;
        this.sections["four"] = true;
      }
    },
    setNav(sectionName) {
      for (var section in this.sections) {
        if (Object.prototype.hasOwnProperty.call(this.sections, section)) {
          this.sections[section] = false;
        }
      }
      this.sections[sectionName] = true;
    },
  },
};
</script>

<style scoped>
.mini-guidelines {
  width: calc(500px / var(--widthResoRatio));
  height: calc(695px / var(--heightResoRatio));
  padding: calc(20px / var(--heightResoRatio)) calc(55px / var(--widthResoRatio));
  box-sizing: border-box;
  overflow: hidden;
}
.mini-guidelines-last-slide {
  height: calc(555px / var(--heightResoRatio));
}
</style>
